export const assignmentTranslateKey: { [key: string]: string } = {
    Function: 'Funkcja',
    FunctionStartDate: 'Data rozpoczęcia pełnienia funkcji',
    FunctionEndDate: 'Przewidywana data zakończenia pełnienia funkcji',
    Decree: 'Rozkaz nadający funkcję',
    AdditionalInformation: 'Dodatkowe informacje rejestrującego',
    UnitName: 'Nazwa jednostki',
}

export const summaryAssignmentTranslateKey: { [key: string]: string } = {
    assignedFunction: 'Funkcja',
    startDate: 'Data rozpoczęcia pełnienia funkcji',
    endDate: 'Przewidywana data zakończenia pełnienia funkcji',
    decree: 'Rozkaz nadający funkcję',
    additionalInformation: 'Dodatkowe informacje rejestrującego',
    unit: 'Jednostka',
    unitName: 'Nazwa jednostki',
}